(function () {
  const params = new URLSearchParams(window.location.search);
  const variant = (params.get("variant") || "").replace(/\D/g, "");
  const path = window.location.pathname || "";
  const isCheckoutPage = path.indexOf("/pages/unonight-checkout") !== -1;
  const isMembershipProduct =
    path.indexOf("/products/medlemskap") !== -1 ||
    path.indexOf("/products/medlemskapsoppgradering") !== -1;
  const isProductPage = path.indexOf("/products/") !== -1;
  const hasMetadata = Boolean(
    params.get("buyer") ||
      params.get("recipient") ||
      params.get("tier") ||
      params.get("gift_intent")
  );
  const hasWishlistGiftMetadata = Boolean(
    params.get("recipient") && (params.get("wishlist_item") || params.get("buyer"))
  );
  const hasVirtualGiftMetadata = Boolean(params.get("gift_intent") && params.get("recipient"));

  if (
    !variant ||
    (!isCheckoutPage &&
      !(isMembershipProduct && hasMetadata) &&
      !(isProductPage && hasWishlistGiftMetadata && !params.get("tier")) &&
      !(isProductPage && hasVirtualGiftMetadata))
  ) {
    return;
  }

  const properties = {};
  const buyer = params.get("buyer");
  const recipient = params.get("recipient");
  const tier = params.get("tier");
  const wishlistItem = params.get("wishlist_item");
  const giftIntent = params.get("gift_intent");
  const virtualGiftProduct = params.get("virtual_gift_product");
  const sourceContext = params.get("source_context");

  if (buyer) properties._unonight_user_id = buyer;
  if (recipient) properties._unonight_recipient_user_id = recipient;
  if (tier) properties._unonight_membership_tier = tier;
  if (wishlistItem) properties._unonight_wishlist_item_id = wishlistItem;
  if (giftIntent) properties._unonight_gift_intent_id = giftIntent;
  if (virtualGiftProduct) properties._unonight_virtual_gift_product_id = virtualGiftProduct;
  if (sourceContext) properties._unonight_source_context = sourceContext;

  const quantity = Math.max(1, parseInt(params.get("quantity") || "1", 10) || 1);

  function checkoutMessages() {
    var bridge =
      document.querySelector(".unonight-checkout-bridge[data-unonight-checkout-loading]") ||
      document.querySelector(".unonight-platform-bar[data-unonight-checkout-loading]");
    return {
      loading:
        (bridge && bridge.getAttribute("data-unonight-checkout-loading")) ||
        "Sender deg til kassen …",
      error:
        (bridge && bridge.getAttribute("data-unonight-checkout-error")) ||
        "Kunne ikke starte kassen. Prøv igjen eller kontakt ordre@unonight.com."
    };
  }

  function ensureLoadingUi() {
    if (document.getElementById("unonight-checkout-loading")) return;

    var messages = checkoutMessages();
    var overlay = document.createElement("div");
    overlay.id = "unonight-checkout-loading";
    overlay.setAttribute(
      "style",
      "position:fixed;inset:0;z-index:9999;display:grid;place-items:center;background:#fff;color:#444;font:16px/1.5 system-ui,sans-serif;text-align:center;padding:24px;"
    );
    overlay.textContent = messages.loading;
    document.body.appendChild(overlay);
  }

  function showError() {
    var messages = checkoutMessages();
    var loading = document.getElementById("unonight-checkout-loading");
    if (loading) {
      loading.textContent = messages.error;
      loading.style.color = "#b42318";
    }
  }

  async function addToCartAndCheckout() {
    var response = await fetch("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({
        items: [{ id: variant, quantity: quantity, properties: properties }]
      })
    });

    if (!response.ok) {
      var payload = await response.json().catch(function () {
        return {};
      });
      console.error("Unonight checkout add failed", payload);
      throw new Error(payload.description || payload.message || "cart_add_failed");
    }

    window.location.href = buildCheckoutRedirectUrl();
  }

  function buildCheckoutRedirectUrl() {
    return "/checkout";
  }

  async function run() {
    ensureLoadingUi();

    if (params.get("step") !== "add") {
      var next = new URL(window.location.href);
      next.searchParams.set("step", "add");
      window.location.replace("/cart/clear?return_to=" + encodeURIComponent(next.pathname + next.search));
      return;
    }

    try {
      await addToCartAndCheckout();
    } catch (error) {
      console.error("Unonight checkout bridge failed", error);
      showError();
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }
})();
